<template>
    <div>
        <div class="modal fade hidden-print" data-name="return" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" style="width: 100%; padding-left: 15px; max-width: 1550px;">
                <div class="modal-content" style="width: 100%;">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">
                            {{trans('warehouseman.return.title')}}
                        </h4>
                    </div>
                    <div v-show="loading==0">
                        <div class="modal-body compact-errors">
                            <div class="row">
                                <div class="col-md-5">
                                    <dc-core-single-select
                                            v-model="form.data.warehouseFrom"
                                            :checked="form.data.warehouseFrom"
                                            :options="warehouses"
                                            :errors="form.options.errors"
                                            name="warehouseFromId"
                                            :show-labels="false"
                                            :custom-label="translateListObj"
                                            :title="trans('warehouseman.return.search.warehouse_from')"
                                    >
                                    </dc-core-single-select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5">
                                    <dc-core-single-select
                                            v-model="form.data.warehouseTo"
                                            :checked="form.data.warehouseTo"
                                            :options="warehouses"
                                            :errors="form.options.errors"
                                            name="warehouseToId"
                                            :show-labels="false"
                                            :custom-label="translateListObj"
                                            :title="trans('warehouseman.return.search.warehouse_to')"
                                    >
                                    </dc-core-single-select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5">
                                    <dc-core-single-select
                                            v-model="form.data.receiver"
                                            :checked="form.data.receiver"
                                            :options="users"
                                            :errors="form.options.errors"
                                            name="receiverId"
                                            :show-labels="false"
                                            :custom-label="translateUserListObj"
                                            :title="trans('warehouseman.return.search.receiver')"
                                    >
                                    </dc-core-single-select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5">
                                    <dc-core-single-select
                                            v-model="form.data.deliver"
                                            :checked="form.data.deliver"
                                            :options="users"
                                            :errors="form.options.errors"
                                            name="deliverId"
                                            :show-labels="false"
                                            :custom-label="translateUserListObj"
                                            :title="trans('warehouseman.return.search.deliver')"
                                    >
                                    </dc-core-single-select>
                                </div>
                            </div>

                            <table class="table table-condensed" style="margin-top: 25px;">
                                <thead>
                                <tr>
                                    <th>{{ trans('warehouseman.return.table.object_type') }}</th>
                                    <th>{{ trans('warehouseman.return.table.object_name') }}</th>
                                    <th>{{ trans('warehouseman.return.table.unit') }}</th>
                                    <th>{{ trans('warehouseman.return.table.meal') }}</th>
                                    <th>{{ trans('warehouseman.return.table.amount_return') }}</th>
                                    <th>{{ trans('warehouseman.return.table.weight')}}</th>
                                    <th>{{ trans('warehouseman.return.table.description') }}</th>
                                    <th style="width: 50px;"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(shift,i) in form.data.shifts" :key="i">
                                    <td>
                                        <simple-form-single-select
                                                v-model="shift.objectType"
                                                :checked="shift.objectType"
                                                :options="objectTypes"
                                                :show-labels="false"
                                                :allow-empty="false"
                                                :custom-label="translateObjectType"
                                        >
                                        </simple-form-single-select>
                                    </td>
                                    <td>
                                        <simple-form-single-select
                                                v-if="shift.objectType"
                                                v-model="shift.object"
                                                :checked="shift.object"
                                                :show-labels="false"
                                                :custom-label="translateListObj"
                                                :options="objects[shift.objectType]"
                                                :allow-empty="false"

                                        >
                                        </simple-form-single-select>
                                        <span v-else>
                                        <i>{{ shift.objectName }}</i>
                                    </span>
                                    </td>
                                    <td>
                                        <div v-if="shift.object">
                                        <span v-if="shift.objectType=='product'">
                                            {{ translateUnit(shift.object.unit) }}
                                        </span>
                                            <span v-else>
                                            {{ translateUnit('piece') }}
                                        </span>
                                        </div>
                                    </td>
                                    <td>
                                        <simple-form-single-select
                                                v-model="shift.mealId"
                                                :checked="shift.mealId"
                                                :options="meals"
                                                label="nameForSelect"
                                                @dispatch="updateMealName({$event}, i)"
                                        ></simple-form-single-select>
                                    </td>
                                    <td><input v-model="shift.amountReturn" type="number" class="form-control"></td>
                                    <td>{{ shift.amountReturn ? dcNumberFormat(shift.object.unitWeight *
                                        shift.amountReturn) : 0 }}
                                    </td>
                                    <td>
                                        <textarea v-model="shift.description" rows="1" class="form-control"></textarea>
                                    </td>
                                    <td>
                                        <button
                                                class="btn btn-danger btn-sm"
                                                :disabled="form.data.shifts.length<=1"
                                                @click="remove(i)"
                                        ><span class="fa fa-minus"></span></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-if="form.options.errors.shifts" class="has-error">
                                <span class="help-block"><p>{{trans('warehouseman.common.table.fill_all_fields')}}</p></span>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" @click="add()">
                                        <i class="fa fa-plus"></i>
                                        {{trans('warehouseman.common.table.add_position')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="print()">
                                <i class="fa fa-print"></i>
                                {{trans('warehouseman.common.print')}}
                            </button>
                            <button type="button" class="btn btn-success spinner" :data-loading-text="loadingText" @click="execute()">
                                <i class="fa fa-undo"></i>
                                {{trans('warehouseman.return.execute')}}
                            </button>
                            <button type="button" class="btn btn-default" data-dismiss="modal" @click="reset()">
                                {{trans('warehouseman.common.close')}}
                            </button>
                        </div>
                    </div>
                    <div v-show="loading > 0" class="modal-body">
                        <span>
                            <h2>{{ trans('form.please_wait') }}...</h2>
                            <ring-loader></ring-loader>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div id="print_return" class="print-block hide" data-name="return">
            <table class="table" style="width: 50%;">
                <tr>
                    <th>{{ trans('warehouseman.return.search.warehouse_from')}}</th>
                    <td>{{ form.data.warehouseFrom ? form.data.warehouseFrom.name : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.return.search.warehouse_to')}}</th>
                    <td>{{ form.data.warehouseTo ? form.data.warehouseTo.name : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.return.search.receiver')}}</th>
                    <td>{{ form.data.receiver ? form.data.receiver.username : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.return.search.deliver')}}</th>
                    <td>{{ form.data.deliver ? form.data.deliver.username : '-' }}</td>
                </tr>
            </table>
            <table class="table" style="margin-top: 30px;">
                <thead>
                <tr>
                    <th>{{ trans('warehouseman.return.table.object_type') }}</th>
                    <th>{{ trans('warehouseman.return.table.object_name') }}</th>
                    <th>{{ trans('warehouseman.return.table.unit') }}</th>
                    <th>{{ trans('warehouseman.return.table.meal')}}</th>
                    <th>{{ trans('warehouseman.return.table.amount_return') }}</th>
                    <th>{{ trans('warehouseman.return.table.description') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(shift, i) in form.data.shifts" :key="i">
                    <td>{{ shift.objectType ? translateObjectType(shift.objectType) : '-' }}</td>
                    <td>{{ shift.object ? shift.object.name : '-' }}</td>
                    <td>
                        <div v-if="shift.object">
                            <span v-if="shift.objectType=='product'">
                                {{ translateUnit(shift.object.unit) }}
                            </span>
                            <span v-else>
                                {{ translateUnit('piece') }}
                            </span>
                        </div>
                        <div v-else>-</div>
                    </td>
                    <td>{{ shift.mealName }}</td>
                    <td>{{ shift.amountReturn }}</td>
                    <td>{{ shift.description }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import SimpleFormSingleSelect from '../../component/simple-form/singleselect.vue'
import DcCoreSingleSelect from '../../component/dccore-form/singleselect.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import store from '../../store/warehouseman'
import warehousemanMixins from '../mixins/warehouseman-mixins'

export default {
  components: {
    SimpleFormSingleSelect,
    DcCoreSingleSelect,
    RingLoader,
  },
  mixins: [warehousemanMixins],
  store,
  data() {
    return {
      loading: 0,
      loadingText : `<i class='fa fa-spinner fa-spin '></i>${Translator.trans('form.please_wait')}`,
      form: {
        data: this.defaultData(),
        options: {
          errors: {},
        },
      },
      events: {
        done: function () {
        },
      },
    }
  },
  computed: {
    warehouses() {
      return this.$store.state.warehouses
    },
    users() {
      return this.$store.state.users
    },
    objectTypes() {
      return this.$store.state.objectTypes
    },
    objects() {
      return this.$store.state.objects
    },
    meals() {
      return this.$store.state.meals
    }
  },
  mounted: function () {

    $('.modal[data-name=return]').on('hidden.bs.modal', () => {
      $('.print-block[data-name=return]').removeClass('visible-print-block')
      this.events.done()
    })
  },
  methods: {
    init() {
      $('#popup_return').button('loading')
      return Promise.all([
        this.$store.dispatch('fetchUsers'),
        this.$store.dispatch('fetchWarehouses'),
        this.$store.dispatch('fetchObjectTypes'),
      ]).then(() => this.$store.dispatch('fetchObjects'))
        .then(() => this.$store.dispatch('fetchMeals'))
        .then(() => {
          $('#popup_return').button('reset')
          return new Promise((resolve) => {
            this.reset()
            this.add()
            this.open()
            this.events.done = () => {
              resolve()
            }
          })

        })
    },
    open() {
      $('.modal[data-name=return]').modal({
        backdrop: 'static',
        keyboard: false
      })
      $('.print-block[data-name=return]').addClass('visible-print-block')
    },
    close() {
      $('.modal[data-name=return]').modal('hide')
    },
    defaultData() {
      return {
        shifts: [],
        warehouseFromId: null,
        warehouseToId: null,
        receiverId: null,
        deliverId: null,
      }
    },
    remove(i) {
      this.form.data.shifts.splice(i, 1)
    },
    add() {
      this.form.data.shifts.push(this.create())
    },
    create() {
      return {
        objectType: null,
        objectId: null,
        unit: null,
        amountReturn: 0,
        description: null,
      }
    },
    checkShifts(shifts) {
      let from = null
      let to = null
      let BreakException = {}

      try {
        shifts.forEach(shift => {
          if (from === null) {
            from = shift.item.warehouseFrom
          } else {
            if (shift.item.warehouseFrom.id !== from.id) {
              throw BreakException
            }
          }

          if (to === null) {
            to = shift.item.warehouseTo
          } else {
            if (shift.item.warehouseTo.id !== to.id) {
              throw BreakException
            }
          }
        })
      } catch (e) {
        if (e === BreakException) {
          return false
        }
      }

      return true
    },
    execute() {
      $('.spinner').button('loading')
      this.prepareDataToSend()
      this.$http.patch(
        Routing.generate('api_warehouseman_patch_return'), this.form.data).then(
        () => {
          this.close()
          this.reset()
          this.events.done()
          $('.spinner').button('reset')
        },
        response => {
          this.handleAjaxError(response, this.form.options)
          $('.spinner').button('reset')
        }
      )
    },
    print() {
      this.printElement('print_return')
    },
    prepareDataToSend() {
      if (this.form.data.warehouseFrom) {
        this.form.data.warehouseFromId = this.form.data.warehouseFrom.id
      }

      if (this.form.data.warehouseTo) {
        this.form.data.warehouseToId = this.form.data.warehouseTo.id
      }

      if (this.form.data.receiver) {
        this.form.data.receiverId = this.form.data.receiver.id
      }

      if (this.form.data.deliver) {
        this.form.data.deliverId = this.form.data.deliver.id
      }

      this.form.data.shifts.forEach((shift, i) => {
        if (shift.object) {
          this.form.data.shifts[i].objectId = shift.object.id
        }
      })
    },

  },
}
</script>
